import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../hooks/useApi"

const useTradingRegions = () => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["trading_regions"],
    scientApi.trading.getTradingRegions,
    {
      retry: 1,
      staleTime: Infinity, // Static list, no need to refresh.
    },
  )

  return {
    regions: data,
    error: error as AxiosError,
    isLoading,
  }
}

export default useTradingRegions
